import { Column } from '../components/report/models/column.model';
import { Filter } from '../components/report/models/filter.model';
import { Report } from '../components/report/models/report.model';

export function orderPreviusList(index: number, list: Array<Column|Filter>) {
  const find = list.find(x => x.Order === index);

  if (find != null) {
    orderPreviusList(index + 1, list);

    find.Order += 1;
  }
}

export function setOrderToList(list: Array<Column|Filter>) {
  list.forEach((value: Column, i: number) => {
    const index = i + 1;
    if (canSetOrder(value, index, list)) {
      orderPreviusList(index, list);
      value.Order = index;
    }
  });
}

function canSetOrder(value: Column | Filter, index: number, list: Array<Column|Filter>): boolean {
  return value.Order == null ||
    value.Order !== index ||
    ((value as Column).IsGroupBy && value.Order !== getOrderOfGroupColumn(value.Order, value, list));
}

export function getOrderOfGroupColumn(order: number, item: Column|Filter, list: Array<Column|Filter>): number {
  const find = list.find(x => x != item && (x as Column).IsGroupBy && (x.Order === order || x.Order === order + 1));

  if (find) {
    order = getOrderOfGroupColumn(order + 1, item, list);
  }

  return order;
}

export function sortListByOrder(list: Array<Column|Filter>, concat: boolean = false): Array<any> {
  let aux = list.sort((a, b) => a.Order - b.Order);

  if (concat) {
    aux = aux.concat();
  }

  return aux;
}

export function getAllColumns(report: Report) : Column[]{
  const columns: Array<Column> = [];

  report.Entities.forEach(entity => {

    for (const item of Object.keys(entity.Columns)) {
      columns.push(entity.Columns[item]);
    }
  });
  return columns.sort((a, b) => a.Order - b.Order);
}


export function isReporGrouped(report: Report):boolean {
  return report.Entities.find(x => x.Columns.find(column => column.IsGroupBy) != null) != null;
}

export function getColumnFilter(alias: string, columns: Column[]): Column {
  return columns.find(x => x.Alias.toUpperCase() === alias.toUpperCase());
}